"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* istanbul ignore file */

var EventEmitter2 = require("eventemitter2");
var ILogger = /*#__PURE__*/function (_EventEmitter) {
  function ILogger() {
    (0, _classCallCheck2["default"])(this, ILogger);
    return _callSuper(this, ILogger, arguments);
  }
  (0, _inherits2["default"])(ILogger, _EventEmitter);
  return (0, _createClass2["default"])(ILogger, [{
    key: "attach",
    value: function attach() {}
  }, {
    key: "debug",
    value: function debug() {}
  }, {
    key: "info",
    value: function info() {}
  }, {
    key: "warning",
    value: function warning() {}
  }, {
    key: "error",
    value: function error() {}
  }, {
    key: "jsError",
    value: function jsError() {}
  }, {
    key: "addAttribute",
    value: function addAttribute() {}
  }, {
    key: "removeAttribute",
    value: function removeAttribute() {}
  }]);
}(EventEmitter2);
module.exports = ILogger;